import { useEffect } from 'react'
import { clearCurrentTsgId, hasTsgSupport, revokeAllTsgTokens } from '../../framework/tsg'
import { showLoadingMask, clearUserSessionForLogout, doLogout } from '../main/ui-lib/utils'
import type { StoreState } from '../../framework/stateTypes'

const useLogout = (state: StoreState) => useEffect(() => {
  if (state.loggingOut) {
    showLoadingMask()
    if (state.oidc) {
      clearCurrentTsgId()
      revokeAllTsgTokens().then(state.oidc.logout)
    }
    else if (hasTsgSupport()) { // TODO: get usermanager
      clearUserSessionForLogout()
      const { location } = window
      if (location.pathname.startsWith('/authentication/')) {
        location.href = '/'
      }
      else {
        location.reload()
      }
    }
    else {
      doLogout()
    }
  }
}, [state.loggingOut, state.oidc])

export default useLogout
